module.exports = __webpack_public_path__ + "img/chaithanya-hospital.f3783613.png";